module.exports = __webpack_public_path__ + "static/img/10.30e5917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/10.png
// module id = E91q
// module chunks = 0